<template>
    <div>
        <v-btn fab
               dark
               color="primarylight"
               class="floating-btn"
               :style="language =='ar'?'left:20px;width:35px;height:35px':'right:20px;width:35px;height:35px' "
               @click="toggleChat">
            <img src="../../assets/images/ai-icon.svg" style="width:20px;margin:auto"/>
            <!--<v-icon color="black">mdi-file-question-outline</v-icon>-->
        </v-btn>
        <v-card v-if="chatVisible"
                class="chat-widget"
                :style="language=='ar'?'left:20px':'right:20px'"
                width="400"
                max-width="400">
            <v-toolbar dense dark color="primary" class="flex-grow-0">
                <v-toolbar-title class="ms-2">
                    {{$t('GenerateSurvey')}}
                </v-toolbar-title>

            </v-toolbar>

            <v-card-text>
                <v-form ref="form" @submit.prevent="submitSurvey" v-model="valid" lazy-validation>
                    <v-text-field v-model="surveyName"
                                  :label="$t('SurveyName')" dense
                                  required :rules="nameRules"></v-text-field>
                    <v-text-field v-model.number="numberOfQuestions"
                                  :label="$t('NumberOfQuestions')"
                                  type="number" :rules="nameRules"
                                  required></v-text-field>
                    <v-btn color="primary" type="submit" :loading="loading">{{$t('GenerateSurvey')}}</v-btn>
                </v-form>
            </v-card-text>


        </v-card>

    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import SurveyService from '@/services/SurveyService.js'
    import BotService from '@/services/BotService.js'
    export default {
        props: {
            value: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                valid: true,
                loading: false,
                chatVisible: this.value,
                surveyName: '',
                numberOfQuestions: 0,
                nameRules: [
                    v => !!v || this.$t('RequiredField')
                ],
                questions: []
                /*questions: [
{
    'question': 'ما مدى رضاك عن الخدمات التي تقدمها البلديات في مجال النظافة العامة؟',
    'type': 'Rating',
    'options': [],
    'subquestions': [],
    'answer': 3
},
{
    'question': 'هل أنت من سكان المناطق التالية؟ (يمكن اختيار أكثر من منطقة)',
    'type': 'Checkboxes',
    'options': ['الرياض', 'جدة', 'الدمام', 'مكة المكرمة', 'المدينة المنورة'],
    'subquestions': [],
    'answer': ['الرياض', 'جدة']
},
{
    'question': 'ما هي الخدمات التي ترى أنها تحتاج إلى تطوير من قبل البلديات؟',
    'type': 'MultipleChoice',
    'options': ['النظافة', 'الحدائق والمتنزهات', 'رصف الطرق', 'إنارة الشوارع', 'سوق تجاري'],
    'subquestions': [],
    'answer': ['النظافة', 'الحدائق والمتنزهات']
},
{
    'question': 'ما تقييمك لجهود البلديات في مجال التخطيط العمراني؟',
    'type': 'BipolarMatrix',
    'options': ['جيد', 'سيء'],
    'subquestions': [
        {
            'question': 'تنظيم البناء',
            'options': ['ممتاز', 'جيد', 'متوسط', 'سيء', 'سيء جداً'],
            'answer': 'متوسط'
        },
        {
            'question': 'تصميم الشوارع',
            'options': ['ممتاز', 'جيد', 'متوسط', 'سيء', 'سيء جداً'],
            'answer': 'متوسط'
        },
        {
            'question': 'تخطيط المناطق السكنية',
            'options': ['ممتاز', 'جيد', 'متوسط', 'سيء', 'سيء جداً'],
            'answer': 'جيد'
        }
    ],
    'answer': 'متوسط'
},
{
    'question': 'هل أنت راضٍ عن آلية التعامل مع شكاوى المواطنين؟',
    'type': 'YesNo',
    'options': [],
    'subquestions': [],
    'answer': 'No'
},
{
    'question': 'ما مدى رضاك عن قنوات التواصل مع البلدية؟',
    'type': 'NPS',
    'options': [],
    'subquestions': [],
    'answer': 7,
    'nps_promoters': 'ممتاز',
    'nps_passives': 'للأسف سيء'
},
{
    'question': 'ما ملاحظاتك على الخدمات المقدمة؟',
    'type': 'TextArea',
    'options': [],
    'subquestions': [],
    'answer': 'توجد بعض الملاحظات حول نظافة الشوارع وآلية جمع النفايات، حيث لا يتم الاهتمام بالنظافة العامة بالشكل المطلوب.'
},
{
    'question': 'هل سبق لك أن زرت أحد مراكز الخدمة التابعة للبلدية؟',
    'type': 'TrickyQuestion',
    'options': ['نعم', 'لا'],
    'subquestions': [],
    'answer': 'نعم'
},
{
    'question': 'كيف تقيم تجربتك في الحصول على تراخيص البناء؟',
    'type': 'ShortAnswer',
    'options': [],
    'subquestions': [],
    'answer': 'إجراءات طويلة ومرهقة'
},
{
    'question': 'ما اقتراحاتك لتحسين الخدمات البلدية؟',
    'type': 'TextArea',
    'options': [],
    'subquestions': [],
    'answer': 'زيادة عدد الحاويات في الأماكن العامة، وتوفير تطبيق إلكتروني لطلبات المواطنين.'
},
{
    'question': 'هل سبق أن شاركت في مبادرات التطوع البلدي؟',
    'type': 'YesNo',
    'options': [],
    'subquestions': [],
    'answer': 'Yes'
},
{
    'question': 'ما هي أكثر المبادرات التي شاركت بها؟',
    'type': 'MultipleChoice',
    'options': ['إزالة الكتابات من على الجدران', 'تشجير الحدائق', 'تنظيف الشواطئ', 'رسم الجداريات'],
    'subquestions': [],
    'answer': ['إزالة الكتابات من على الجدران', 'تشجير الحدائق']
},
{
    'question': 'كيف تعلمت عن تلك المبادرات؟',
    'type': 'MultipleChoice',
    'options': ['الصحف', 'التلفزيون', 'السوشال ميديا', 'الرسائل النصية', 'الإيميل'],
    'subquestions': [],
    'answer': ['السوشال ميديا']
},
{
    'question': 'هل أنت من مستخدمي تطبيقات البلدية؟',
    'type': 'YesNo',
    'options': [],
    'subquestions': [],
    'answer': 'Yes'
},
{
    'question': 'ما التطبيقات التي تستخدمها؟',
    'type': 'Dropdown',
    'options': ['أمان', 'بلدي', 'آخر'],
    'subquestions': [],
    'answer': 'أمان'
},
{
    'question': 'هل واجهت أي صعوبات في استخدامها؟',
    'type': 'TextArea',
    'options': [],
    'subquestions': [],
    'answer': 'واجهت صعوبة في تحديث البيانات، حيث يطلب مني التطبيق إعادة التسجيل من جديد.'
},
{
    'question': 'هل سبق أن تقدمت بشكوى للبلدية؟',
    'type': 'YesNo',
    'options': [],
    'subquestions': [],
    'answer': 'Yes'
},
{
    'question': 'ما قنوات التواصل التي استخدمتها؟',
    'type': 'Checkboxes',
    'options': ['الهاتف', 'الموقع الإلكتروني', 'تطبيق البلدية', 'الزيارة الشخصية'],
    'subquestions': [],
    'answer': ['الهاتف', 'الموقع الإلكتروني']
},
{
    'question': 'هل تم الرد على شكواك؟',
    'type': 'YesNo',
    'options': [],
    'subquestions': [],
    'answer': 'Yes'
},
{
    'question': 'هل تم حل المشكلة؟',
    'type': 'YesNo',
    'options': [],
    'subquestions': [],
    'answer': 'Yes'
},
{
    'question': 'ما مدى رضاك عن حل المشكلة؟',
    'type': 'Rating',
    'options': [],
    'subquestions': [],
    'answer': 4
},
{
    'question': 'متى قمت بآخر زيارة لموقع البلدية الإلكتروني؟',
    'type': 'Date',
    'options': [],
    'subquestions': [],
    'answer': '2023-07-15'
},
{
    'question': 'هل واجهت أي صعوبات في تصفح الموقع؟',
    'type': 'TextArea',
    'options': [],
    'subquestions': [],
    'answer': 'الموقع يحتاج إلى تحديث وتصميم أكثر مرونة.'
},
{
    'question': 'هل لديك أي اقتراحات أخرى؟',
    'type': 'TextArea',
    'options': [],
    'subquestions': [],
    'answer': 'زيادة الرقابة على المحلات التجارية، وتطبيق الغرامات على المخالفين.'
}
],*/
            }
        },
        computed: {
            ...mapGetters('user', ['language']),

            getLanguage() {
                return this.language == null ? 'ar' : this.language

            },
        },
        watch: {
            value(newValue) {
                this.chatVisible = newValue // Sync when prop changes
            }
        },
        methods: {
            toggleChat() {
                this.chatVisible = !this.chatVisible  // Toggle chat visibility
                this.$emit('openai', this.chatVisible)
            },
            async submitSurvey() {
                if (this.$refs.form.validate()) {
                    this.loading = true
                    var result = await BotService.generateSurveyFromAI(this.surveyName, this.numberOfQuestions)
                    this.questions = result.data
                    const payload = {
                        nameAr: this.surveyName,
                        nameEn: this.surveyName,
                        questions: this.questions,
                    }
                    var result = await SurveyService.generateSurvey(payload)

                    this.$router.push('/add-survey??id=' + result.data.id)
                    this.loading = false
                    this.chatVisible = false

                }


            },
        },
    }
</script>

<style>
    .rotate-180 {
        transform: rotate(180deg);
    }
    /* Floating Button */
    .floating-btn {
        position: fixed !important;
        bottom: 100px;
    }

    /* Chat Widget */
    .chat-widget {
        position: fixed !important;
        bottom: 80px;
        height: 400px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
</style>
